<script>
import Layout from '@layouts/main'
import appConfig from '@src/app.config'
import api from '@/odooapi'
import rpc from '@/odoorpc'

/**
 * Dashboard-1 Component
 */
export default {
  page: {
    title: '客户指令',
    meta: [{
      name: 'interaction',
      content: appConfig.description
    }],
  },
  components: {
    Layout,
  },

  data() {
    return {
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        roleName: undefined,
        roleKey: undefined,
        status: undefined
      },
// 分页信息
      paginationData: {
        pageIndex: 1,
        pageSize: 10,
        total: 0
      },

      allData: [],  // 全部表格数据
      tableData: [],  // 当前页表格数据，这个绑定给el-table

      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      maxHeight: '328px',
      // 日期范围
      dateRange: [],
      // 数据列表
      salesList: [],

      // loading: true,

      // 新建往来
      addForm: {
        name: '',
        note: '',
        type: 'other',
      },

      rawData: {},
      diffData: {},

      // 跟新表单
      updateForm: {
        name: '',
        note: '',
        type: ''
      },

      // 回复往来
      recoverForm: {
        'content': ''
      },
      // 往来记录
      activities: [],

      dialogVisible: false,
      dialogUpdateVisible: false,
      dialogRecoverVisible: false,

      addFormRules: {
        name: [
          {required: true, message: '请输入名称', trigger: 'blur'},
        ],

        type: [
          {required: true, message: '请选择指令类型', trigger: 'blur'},
        ],
        note: [
          {required: true, message: '请填写描述', trigger: 'blur'},
        ],

      },

      // 查询参数
      // queryParams: {
      //   pageNum: 0,
      //   pageSize: 10,
      // },
      // domain: [],
      // fields: ['partner_id', 'order_id', 'client_order_ref', 'order_type', 'product_cat',
      //   'product_tmpl_id', 'production_qty'
      // ],
      // order: 'id DESC',
      state: '',
      options: [{
        value: '选项1',
        label: '新建'
      }, {
        value: '选项2',
        label: '报价'
      }, {
        value: '选项3',
        label: '评审'
      }, {
        value: '选项4',
        label: '确认'
      }, {
        value: '选项5',
        label: '执行'
      }],
      value: ''

    }
  },
  created() {
    this.getList()
  },
  methods: {
    /** 点击table跳转 */
    handle(val) {
      this.$router.push({
        name: '销售订单详情',
      })
    },
    // 新增按钮
    actionForm() {
      this.addForm = {
        name: '',
        note: '',
      }
      this.dialogVisible = true
    },
    // 修改按钮  弹出表单
    handleUpdate(val) {
      this.getRecords(val)
      console.log(val)
      this.updateForm = {
        'interaction_id': val.id,
        'name': val.name,
        'type': val.type,
        'partner_name': val.partner_name,
        'note': val.note
      }
      this.rawData = {
        'interaction_id': val.id,
        'name': val.name,
        'type': val.type,
        'partner_name': val.partner_name,
        'note': val.note
      }
      this.dialogUpdateVisible = true
    },

    diffFormData() {
      for (let k in this.rawData) {
        if (this.rawData[k] !== this.updateForm[k]) {
          if (!this.diffData) {
            this.diffData = {}
          }
          this.diffData[k] = this.updateForm[k]
        }
      }
    },
    updateApprove() {
      this.diffFormData()
      if (!this.diffData) {
        this.$message.error('未修改数据，无需提交')
      } else {
        const Model = api.env.model('client.interaction')
        Model.write(
            this.updateForm.interaction_id, this.diffData
        )
      }
      this.dialogUpdateVisible = false

    },

    // 获取往来记录
    getRecords(val) {
      rpc.web.dataset.call_kw({
        model: 'client.interaction',
        method: 'get_activities',
        args: [],
        kwargs: {'interaction_id': val.id}
      }).then(res => {
        this.activities = res
      })
    },

    // 回复按钮
    handleRecover(val) {
      this.recoverForm = {
        'interaction_id': val.id,
        'type': 'customer',
        'content': ''
      }
      this.dialogRecoverVisible = true
    },

    // 立即创建
    addBrand() {
      const Model = api.env.model('client.interaction')
      Model.create(
          this.addForm
      )
          .then((res) => {
            this.$message({
              message: '恭喜你，这是一条成功消息',
              type: 'success'
            });
          })
          .catch((e) => {
            this.$message.error('错了哦，这是一条错误消息');
          })
      this.dialogVisible = false
      this.getList()

    },

    // 确认回复
    addApprove() {
      const Model = api.env.model('interaction.record')
      Model.create(
          this.recoverForm
      )
      this.dialogRecoverVisible = false
      this.getList()
    },


    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },

    handleSizeChange(val) {
      this.paginationData.pageSize = val
      this.getList()
    }
    ,
    handleCurrentChange(val) {
      this.paginationData.pageIndex = val
      this.getList()
    },
    // 处理标签
    filterTag(value, row) {
      return row.tag === value;
    },
    // 动态切换状态
    tagTypeChange(status) {
      if (status === '已完成') {
        return "success";
      } else if (status === '待处理') {
        return "danger";
      } else if (status === '处理中') {
        return "primary";
      } else {
        return "info";
      }
    },

    // 获取数据
    getList() {
      this.queryParams.pageNum = 0;
      // const Model = api.env.model('sale.order.productions')
      rpc.web.dataset.call_kw({
        model: 'client.interaction',
        method: 'search_client_interaction',
        args: [],
        kwargs: {}
      }).then(res => {
        this.allData = res
        this.tableData = this.allData.slice((this.paginationData.pageIndex - 1) * this.paginationData.pageSize, this.paginationData.pageIndex * this.paginationData.pageSize)
        this.paginationData.total = this.allData.length
        this.tableData.forEach((el, i) => {
          el.$index = (this.paginationData.pageIndex - 1) * this.paginationData.pageSize + 1 + i;
        });
      })
    },
  }
}
</script>

<template>
  <Layout>
    <div class="row page-title align-items-center">
      <div class="col-sm-4 col-xl-6">
        <h4 class="mb-1 mt-0">客户指令</h4>
      </div>
    </div>
    <!--新建弹窗-->
    <el-dialog
        title="新建往来"
        :visible.sync="dialogVisible"
        width="50%"
    >
      <!--弹出的对话框的内容-->
      <el-form ref="form" :model="addForm" label-width="100px" label-position="left" :rules="addFormRules">
        <el-row :gutter="20">
          <el-col :span="12" class="grid-content bg-purple">
            <el-form-item label="名称" prop="name">
              <el-input v-model="addForm.name"/>
            </el-form-item>
          </el-col>
          <el-col :span="12" class="grid-content bg-purple">
            <el-form-item label="类型" prop="type" content="Top Left 提示文字">
              <el-select v-model="addForm.type" placeholder="请选择类型">
                <el-option label="发货" value="stock"></el-option>
                <el-option label="其他" value="other"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" class="grid-content bg-purple">
            <el-form-item label="描述" prop="note">
              <el-input v-model="addForm.note" type="textarea"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item>
          <el-button type="primary" @click="addBrand">立即创建</el-button>
          <el-button @click="dialogVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!--回复弹窗-->
    <el-dialog
        title="回复"
        :visible.sync="dialogRecoverVisible"
        width="50%"
    >
      <!--弹出的对话框的内容-->
      <el-form ref="form" :model="addForm" label-width="100px" label-position="left">
        <el-form-item label="回复内容">
          <el-input v-model="recoverForm.content" type="textarea"/>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addApprove">确认</el-button>
          <el-button @click="dialogRecoverVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!--修改-->
    <el-dialog
        title="详情"
        :visible.sync="dialogUpdateVisible"
        width="60%"
    >
      <el-form ref="form" :model="updateForm" label-width="100px" label-position="left">
        <el-row :gutter="20">
          <el-col :span="12" class="grid-content bg-purple">
            <el-form-item label="名称" prop="name">
              <el-input v-model="updateForm.name" disabled="disabled"/>
            </el-form-item>
          </el-col>
          <el-col :span="12" class="grid-content bg-purple">
            <el-form-item label="类型" prop="type">
              <el-select v-model="updateForm.type" placeholder="请选择类型" disabled="disabled">
                <el-option label="发货" value="stock"></el-option>
                <el-option label="其他" value="other"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" class="grid-content bg-purple">
            <el-form-item label="描述" prop="note">
              <el-input v-model="updateForm.note" type="textarea"/>
            </el-form-item>
          </el-col>
        </el-row>
        <h4>往来记录</h4>
        <div class="block">
          <el-timeline :reverse="true">
            <el-timeline-item
                v-for="(activity, index) in activities"
                :key="index"
                :timestamp="activity.date">
              {{ activity.content }}
            </el-timeline-item>
          </el-timeline>
        </div>
        <el-form-item>
          <el-button type="primary" @click="updateApprove">确认</el-button>
          <el-button @click="dialogUpdateVisible = false">取消</el-button>
        </el-form-item>
      </el-form>


    </el-dialog>

    <div class="row">
      <div class="col">
        <div class="card">
          <div class="card-body p-0">
            <div style="margin-top: 0.6rem;">
              <div class="col-sm-4 col-xl-6 text-sm-right">
                <el-row :gutter="10">
                  <el-col :span="1.5">
                    <el-button
                        type="primary"
                        plain
                        icon="el-icon-plus"
                        size="mini"
                        @click="actionForm"
                    >新增
                    </el-button>
                  </el-col>
                </el-row>
              </div>
              <!--列表-->
              <el-table :data="tableData" style="width: 100%" class="p-3">
                <el-table-column type="selection" width="55" align="center"/>
                <el-table-column v-if="false" label="ID" prop="id" />
                <el-table-column v-if="false" label="客户" prop="partner_name"/>
                <el-table-column prop="name" label="名称"/>
                <el-table-column prop="type" label="类型"/>
                <el-table-column prop="note" label="描述"/>
                <el-table-column prop="state" label="状态"
                                 :filter-method="filterTag" filter-placement="bottom-end">
                  <template v-slot="scope">
                    <el-tag
                        v-if="scope.row.state"
                        :type="tagTypeChange(scope.row.state)"
                        close-transition>{{ scope.row.state }}
                    </el-tag>
                  </template>
                </el-table-column>

                <el-table-column prop="content" label="最新回复"/>

                <el-table-column prop="create_date" label="创建时间"/>


                <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
                  <template v-slot="scope">
                    <el-button v-hasPermi="['system:role:edit']" size="mini" icon="el-icon-edit"
                               type="text" @click="handleRecover(scope.row)">回复
                    </el-button>
                    <el-button v-hasPermi="['system:role:edit']" size="mini" icon="el-icon-edit"
                             type="text" @click="handleUpdate(scope.row)">修改
                    </el-button>

                  </template>
                </el-table-column>
              </el-table>
              <el-pagination background style="margin-top: 20px; text-align: right;"
                             layout="total, sizes, prev, pager, next, jumper"
                             :total="paginationData.total"
                             :page-size="paginationData.pageSize"
                             :current-page="paginationData.pageIndex" :page-sizes="[10, 30, 50]"
                             @size-change="handleSizeChange"
                             @current-change="handleCurrentChange"
              >
              </el-pagination>
            </div>


          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
.el-table th.el-table__cell {
  background-color: #f8f8f9;
}

/*.el-form-item {*/
/*  margin-bottom: -0.5rem;*/
/*}*/

.el-table th.el-table__cell.is-leaf,
.el-table td.el-table__cell {
  border-bottom: 1px solid #dfe6ec;
}

.el-table .el-dropdown-link {
  cursor: pointer;
  color: #409EFF;
  margin-left: 5px;
}

/*.el-input {*/
/*  width: 130px;*/
/*}*/

</style>